<template>
  <div class="row">
    <div class="col-6">

      <!-- CASE TITLE -->
      <h3 id="case-id" class="mb-1">
        # {{ headerId }} - {{ formatCaseType(caseType) }}
      </h3>

      <!-- HISTORICAL VERSION -->
      <span v-if="!active">
        {{ 'VERSION' | translate }}: {{ version }}
      </span>

      <span v-if="!active && customer" class="separator">|</span>

      <!-- CUSTOMER -->
      <span v-if="customerUniqueId || batchId">
        <span v-if="customerUniqueId">
          {{ 'RELATION' | translate }}:
          <router-link class="font-weight-semibold" :to="'/customer/' + customerUniqueId">
            {{ customerName ? customerName : customerUniqueId }}
          </router-link>
        </span>
        <span v-if="customerUniqueId && batchId"> | </span>
        <span v-if="batchId">
          {{ 'Batch Id' | translate }}:
          <router-link class="font-weight-semibold" :to="'/cases/' + '?page=1&batch=' + batchId">
            {{ batchId }}
          </router-link>
        </span>
      </span>

    </div>
    <div class="col-6 text-right">
      <h5 class="font-weight-normal mb-1">

        <!-- LOCK -->
        <label class="user-lock" :class="{ 'locked': localUserLocked }"
          v-tooltip.left="$options.filters.translate(localUserLocked ? 'UNLOCK_CASE' : 'LOCK_CASE')">
        <input type="checkbox" name="userLocked" id="userLocked" class="user-lock"
               v-if="active" v-model="localUserLocked"
               :disabled="disabledLockChecbox || isLockedForMe || hasNoEditRights"
            @change="changeLockStatus">
          <i class="fa" :class="[ localUserLocked ? 'fa-lock' : 'fa-unlock-alt' ]" aria-hidden="true"></i>
        </label>

        <!-- CASE STATUS -->
        {{ 'STATUS' | translate }}:
        <span class="font-weight-semibold">{{ active ? status : 'HISTORICAL' | translate('status') }}</span>

        <!-- STATUS REASON -->
        <span class="status-reason" v-if="statusReason" v-tooltip.left="statusReason">
          <i class="fa fa-info-circle text-info" aria-hidden="true"></i>
        </span>

      </h5>

      <!-- LAST USER TO EDIT -->
      <small>
        {{ 'LAST_EDIT_USER' | translate }}:
        <span class="font-weight-semibold">{{ lastUser }}</span>
      </small>

      <span class="separator">|</span>

      <!-- LAST TIME EDITED -->
      <small>
        {{ 'LAST_EDIT_TIME' | translate }}:
        <span class="font-weight-semibold">{{ formattedLastUpdatedDate }}</span>
      </small>

    </div>
  </div>
</template>

<script>
import RestService from '../../service/RestService';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  props: ['headerId', 'batchId', 'version', 'caseType', 'status', 'statusReason', 'active', 'userLocked', 'isLockedForMe', 'hasNoEditRights',
    'lastUser', 'lastUpdated', 'customerUniqueId', 'customerName'],
  async beforeMount() {
    this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
  },
  data: function () {
    return {
      rest: this.initRestService(),
      localUserLocked: this.userLocked,
      disabledLockChecbox: false,
      enabledProductLines: []
    }
  },
  computed: {
    formattedLastUpdatedDate() {
      return new Date(Date.parse(this.lastUpdated)).toLocaleDateString('nl-NL', {
        'weekday': 'long',
        'year': 'numeric',
        'month': 'numeric',
        'day': 'numeric',
        'hour': 'numeric',
        'minute': 'numeric',
        'second': 'numeric'
      });
    }
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    formatCaseType(caseType) {
      const productLine = this.enabledProductLines.find(productLine => productLine.name === caseType);
      return productLine ? productLine.description : '';
    },
    changeLockStatus() {
      this.disabledLockChecbox = true;
      return this.rest.setUserLocked(this.headerId, this.localUserLocked)
        .then(() => {
          this.disabledLockChecbox = false;
          this.$emit('reload-case');
        })
        .catch((err) => {
          this.localUserLocked = this.userLocked;
          this.disabledLockChecbox = false;
          this.$emit('error', 'error.LOCK_CHANGE_FAILED');
          this.$log.error(err.response.data);
        });
    }
  }
}
</script>

<style scoped>
.separator {
  margin: 0 4px;
}

.user-lock {
  margin: 0 5px;
  padding: 0 5px;
  display: inline-block;
  font-size: 1.5rem;
  color: #616161;
  cursor: pointer;
  transform: translateY(2px);
}

.user-lock.locked {
  color: #00628D;
}

.user-lock input {
  display: none;
}

.status-reason {
  margin-left: 5px;
  display: inline-block;
  font-size: 1rem;
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/components/case/PolicyCaseDetails.vue